/**
 * Inline literal values for a Function Call node's input parameters.
 *
 * An unwired parameter pin shows a typed box on the node (Unreal-Blueprint
 * style); what's typed is stored on the node as `data.args[paramName]`. A wired
 * pin always wins — the literal is only the value of a pin with no wire.
 *
 * The stored value is coerced to the parameter's CURRENT type on read, because
 * the function's signature can change after the value was typed (a string param
 * retyped to int keeps its old "abc" until someone edits it). What the box shows
 * and what the runtime passes come from this one function, so they can't
 * disagree.
 */

export function fnArgLiteral(type, raw) {
  switch (type) {
    case 'bool':
      if (typeof raw === 'string') return raw.trim().toLowerCase() === 'true'
      return !!raw
    case 'int': {
      const n = typeof raw === 'number' ? raw : parseFloat(raw)
      return Number.isFinite(n) ? Math.trunc(n) : 0
    }
    case 'float': {
      const n = typeof raw === 'number' ? raw : parseFloat(raw)
      return Number.isFinite(n) ? n : 0
    }
    default:
      return raw == null ? '' : String(raw)
  }
}

/** The literal for one parameter of a functionCall node's data. */
export function fnArgValue(data, param) {
  return fnArgLiteral(param.type, data?.args?.[param.name])
}
